import { Reducer } from 'redux';
import { KpiEAIState, KpiEAITypes } from './types';

const INITIAL_STATE: KpiEAIState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<KpiEAIState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KpiEAITypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case KpiEAITypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };

    case KpiEAITypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: INITIAL_STATE.data,
      };
    default:
      return state;
  }
};

export default reducer;
